import "./tab0.scss";
import * as React from "react";
import DotIndicator from "../../../../../../ui/dotindicator/dotindicator";
import DatePicker from "../../../../../../ui/datepicker/datepicker";
import Button from "../../../../../../core/button/button";
import HorizontalDivider from "../../../../../../ui/horizontaldivider/horizontaldivider";
import Dropdown from "../../../../../../ui/dropdown/dropdown";
import {DropDownItem} from "../../../../../../modals/types/dropdown";

const Tab0 = () => {
    const contentDropDownItems: DropDownItem[] = [
        {label: "صنعتی"}, {label: "مواد غذایی"}, {label: "مهندسی"}, {label: "صنایع"}
    ];
    return (
        <div className="Tab0">
            <div className="row">
                <div className="d-flex align-items-center mt-1 mb-1">
                    <DotIndicator/>
                    <span>تنظیمات کلی</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-4 pb-1">عنوان کمپین</h6>
                    <input type="text" name="" id="" className="Campaign-Input" placeholder="مثال:عسل"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3"></div>
                <HorizontalDivider/>
                <div className="d-flex align-items-center mt-1 mb-1">
                    <DotIndicator/>
                    <span>تنظیمات تبلیغ</span>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-4 pb-1">نوع محتوا</h6>
                    <Dropdown items={contentDropDownItems} placeHolder="انتخاب کنید"/>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mb-3">
                    <h6 className="pt-3 mt-1 pb-0">بازه زمانی برای پخش</h6>
                    <div className="d-flex justify-content-end align-items-center Date-Picker-Box">
                        <DatePicker/>
                        <Button type={"secondary"} action={() => {

                        }} responsive={false}>انتخاب تاریخ</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Tab0;